<template>
  <div>
    <div class="opo02">
      <span class="opo03" @click="toBack">历史记录 ></span>
      <span class="opo03"> 查看详情</span>
    </div>
    <div class="opo01">
      <div class="opd1">
        <div class="opd2">
          <div class="opd3">姓名：{{data.name}}</div>
          <div class="opd3">卡号：{{data.cardno}}</div>
          <div class="opd3">工业云账号：{{data.mobile}}</div>
          <div class="opd3">总金额：{{data.total}}</div>
        </div>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06de">
        <div class="djt26ode">商品名称</div>
        <div class="djt26ode">商品编码</div>
        <div class="djt26ode">领取时间</div>
        <div class="djt26ode">领取数量</div>
        <div class="djt26ode">实际出货数量</div>
        <div class="djt26ode">领取方式</div>
        <div class="djt26ode">金额</div>
        <div class="djt26ode">状态</div>
      </div>
      <template>
        <div class="djt09de" v-for="(item,index) in data.details" :key="'lis'+index">
          <div class="djt2712de" :title="item.name">{{item.name}}</div>
          <div class="djt2712de" :title="item.code">{{item.code}}</div>
          <div class="djt2712de" :title="item.ctime">{{item.ctime}}</div>
          <div class="djt2712de" :title="item.num">{{item.num}}</div>
          <div class="djt2712de" :title="item.num">{{item.actualnum}}</div>
          <div class="djt2712de" v-if="data.paytypeid == 1" title="支付宝">支付宝</div>
          <div class="djt2712de" v-else-if="data.paytypeid == 2" title="微信">微信</div>
          <div class="djt2712de" v-else title="刷卡">刷卡</div>
          <div class="djt2712de" :title="item.totalprice">{{item.totalprice}}</div>
          <div class="djt2712de" style="color: #2176FA" v-if="item.state == 3 && type == 1">正常</div>
          <div class="djt2712de" style="color: #FFC400" v-if="item.state == 2 && type == 1">出货异常</div>
          <div class="djt2712de" style="color: red" v-if="item.state == 1 && type == 1">待出货</div>
          <div class="djt2712de" style="color: red" v-if="item.state == 4 && type == 1">订单已取消</div>
          <div class="djt2712de" style="color: #2176FA" v-if="item.state == 3 && (type == 2 || type == 3)">已确认</div>
          <div class="djt2712de" style="color: red" v-if="item.state == 1 && (type == 2 || type == 3)">待确认</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  export default {
    name: "OrderDetail",
    data(){
      return{
        data:[],
        type:0,
      }
    },
    created() {
      me = this;
      me.data = JSON.parse(me.$route.query.data);
      me.type = me.$route.query.type;
      console.log(me.data,"ddd");
    },
    mounted() {
    },
    methods:{
      toBack(){
        me.$router.back();
      }
    }
  }
</script>

<style scoped>
@import "OrderDetail.css";
</style>